export default {
  id: 204,
  title: 'Target #204 - Deadpool',
  url: 'https://cssbattle.dev/play/204',
  colors: ['#F3AC3C', '#000000', '#FFFFFF', '#9F3333'],
  solution:
    '<p a><p b><style>p[a],p[b]{background:#fff;top:126;width:30;height:15;border-radius:0 0 1in 1in}body{background:radial-gradient(circle at 50% 154px,transparent 83px,#9f3333 83px 100px,#f3ac3c 100px),linear-gradient(90deg,#000 182px,#9f3333 182px 218px,#000 218px)}p{position:fixed}p[a]{left:134.5;rotate:29deg}p[b]{right:135.5;rotate:-29deg',
}
